<template>
    <base-steps ref="stepper" hideButtons class="d-flex flex-column" style="min-height: 100%; align-items: stretch;">
        <div>
             <base-card>
                <base-question text="Extras"/>
                <div class="option-step" v-for="(extra, i) in category.extra_ingredients" :key="i">
                    <base-checkbox :label="extra.name" :defaultValue="1" v-model="extra.quantity" :checked="!!extra.quantity" @change="addIngredientExtra"/>
                    <p class="price-step">R$ {{(+extra.sizes[0].price || 0).toFormat(StringLanguage.currencyConfigs)}}</p>
                </div>
            </base-card>
        </div>
        <div>
            <base-card>
                <base-question text="Alguma observação?"/>
                <base-textarea label="Insira uma observação" rows="5" v-model="product.observation" class="mb_5" />
            </base-card>
        </div>
    </base-steps>
</template>
<script>
import Vue from 'vue';
import BaseSteps from '@/components/Steps'
import BaseCard from '@/components/Card'
import BaseQuestion from '@/components/Question'
import BaseRadio from '@/components/Radio'
import BaseCheckbox from '@/components/Checkbox'
import BaseTextarea from '@/components/Textarea'
import BaseDrawer from '@/components/Drawer'
import BaseButton from '@/components/Button'

export default {
    components: {
        BaseSteps,
        BaseCard,
        BaseQuestion,
        BaseRadio,
        BaseCheckbox,
        BaseTextarea,
        BaseDrawer,
        BaseButton
    },
    props: {
        product: { type: Object },
        category: { type: Object }
    },
    mounted() {
        this.$emit('updatePrice', this.product)
        if((this.category.extra_ingredients || []).length == 0) {
            this.$refs.stepper.current = 2;
        }
    },
    methods: {
        addIngredientExtra() {
            Vue.set(this.product, 'extra_ingredients', this.category.extra_ingredients.filter(i => i.quantity > 0))
            this.$emit('updatePrice', this.product);
        },
        next() {
            if(this.$refs.stepper) {
                this.$refs.stepper.next();
            }
        },
        prev() {
            if(this.$refs.stepper) {
                if((this.category.extra_ingredients || []).length == 0) {
                    this.$refs.stepper.current = 2;
                } else {
                    this.$refs.stepper.prev();
                }
            }
        },
    }
}
</script>
<style scoped>
    .option-step {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 25px;
    }

    .price-step{
        font-size: 1.2em;
        color: #AAAAABD4;
    }
</style>